/**
 * ContentManager module
 *
 * This module manage content with creation, events, etc..
 *
 */

'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const AbstractContent = require('./../model/AbstractContent');
const Content = require('./../model/Content');
const ContentSet = require('./../model/ContentSet');
const DefinitionManager = require('./DefinitionManager');
const ContentContainer = require('./ContentContainer');
const ContentRepository = require('./../repository/ContentRepository');
const SaveManager = require('./SaveManager');
const ObjectIdentifier = require('./../../../services/objectIdentifier');

const HEADER_RESOURCE_UID = 'BB-RESOURCE-UID';

let ContentManager = {};

let contentSetToRemove = [];

/**
 * Build element with basic config (type and uid)
 * verify if is ContentSet
 * and add to the content container
 *
 * @param  {object} config
 * @returns {object} AbstractContent
 */
ContentManager.buildElement = function(config) {
  if (!_.isObject(config)) {
    throw new Error('Config must be set in ContentManager::buildElement');
  }

  let definition;
  let content;
  let allowedData;
  let data;

  if (_.isString(config.id)) {
    content = ContentContainer.get(config.id);

    if (null !== content) {
      content.$ = config.$ || content.$;
    }

    return content;
  }

  if (!_.isString(config.type) || !_.isString(config.uid)) {
    throw new Error('Type or uid is missing in ContentManager::buildElement');
  }

  definition = DefinitionManager.get(config.type);
  data = {
    'uid': config.uid,
    'type': config.type,
    '$': config.$ || null,
    'definition': definition,
  };

  if (null === definition) {
    throw new Error('Definition cannot be null in ContentManager::buildElement');
  }

  content = (true === definition.properties.is_container) ? new ContentSet(data) : new Content(data);

  if (_.isObject(config.data)) {
    if (!content.data) {
      allowedData = [
        'elements',
        'extra',
        'image',
        'label',
        'parameters',
        'type',
        'uid',
      ];

      content.data = {};

      _.forEach(config.data, function(currentData, key) {
        if (-1 !== allowedData.indexOf(key)) {
          content.data[key] = currentData;
        }
      });
    }
  }

  ContentContainer.add(content);

  return content;
};

/**
 * Retrieve the position to insert element
 * into the ContentSet
 *
 * @param {object} $zone
 * @param {string} classes
 * @returns {Integer} position
 */
ContentManager.getPosition = function($zone, classes) {
  let position = 0;
  let direction = $zone.hasClass('vertical') ? '.vertical' : '.horizontal';

  classes = classes || '.cloud-dnd' + direction;

  jQuery($zone.prevAll(classes).get().reverse()).each(function() {
    position = position + 1;
  });

  return position;
};

ContentManager.refreshResizeImage = function() {
  jQuery('.cloudcontentset').each(function() {
    let $cloudContentSet = jQuery(this);
    let resizeImage;

    resizeImage = $cloudContentSet.find('.row:first').children().not('.cloud-dnd, .cloud-column-resize').length > 1;

    $cloudContentSet.find('.media-image').each(function() {
      jQuery(this)[resizeImage ? 'addClass' : 'removeClass']('image-resize');
      jQuery(this)[!resizeImage ? 'addClass' : 'removeClass']('image-fullwidth');
    });
  });
};

/**
 * Retrieve the rootContentSet
 *
 * @returns {object} rootContentset
 */
ContentManager.getRootContentSet = function() {
  return this.getContentByNode(jQuery('.rootContentSet'));
};

ContentManager.refreshjQueryObject = function(content) {
  if (content instanceof AbstractContent) {
    content.$ = jQuery('[data-bb-identifier="' + content.type + '(' + content.uid + ')"]');
  }
};

ContentManager.transformColContentSet = function($colContentSet) {
  let colContentSet = ContentManager.getContentByNode($colContentSet);
  let $children = colContentSet.$.children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content');
  let transform;
  let promises = [];

  transform = function(content, cloudContentSet) {
    let dfd = jQuery.Deferred();

    ContentManager.createElementWithSub('CloudContentSet', 'ColContentSet')
      .done(function(newCloudContentSet, newColContentSet) {
        newColContentSet.setElements([
          {
            'uid': content.uid,
            'type': content.type,
          },
        ]);

        SaveManager.save().done(function() {
          newCloudContentSet.getHtml().done(function($html) {
            content.$.remove();

            colContentSet.setUpdated(true);

            $html.insertAfter(cloudContentSet.$);
            require('./../service/dndZone').apply();

            ContentManager.getRootContentSet().setUpdated(true);

            dfd.resolve();
          });
        });
      });

    return dfd.promise();
  };

  $children.each(function(index) {
    if (index > 0) {
      let content = ContentManager.getContentByNode(jQuery(this));
      let cloudContentSet = content.getCloudContentSet();

      promises.push(transform(content, cloudContentSet));
    }
  });

  return jQuery.when.apply(undefined, promises).promise();
};

ContentManager.removeStylesFromDnd = function() {
  jQuery('.colcontentset').parent().removeAttr('style');
};

ContentManager.removeHtml = function(content, cloudContentSet, colContentSet) {
  let $row;
  let $colContentSet;
  let $colMd;
  let data = {
    'transform': false,
  };

  if (content instanceof AbstractContent) {
    colContentSet = colContentSet || content.getColContentSet();
    cloudContentSet = cloudContentSet || content.getCloudContentSet();

    $row = colContentSet.$.parents('.row:first');
    $colMd = colContentSet.$.parent();

    if (colContentSet.$.children().not('.cloud-dnd, .cloud-column-resize, .ghost-dnd, .cloud-dnd-content').length > 1) {
      content.$.remove();
      colContentSet.setUpdated(true);
    } else {
      if ($row.children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content').length <= 1) {
        cloudContentSet.$.remove();
        ContentManager.removeContentSet(cloudContentSet);
      } else {
        $colMd.remove();
        cloudContentSet.buildColumn();
        cloudContentSet.setUpdated(true);

        $colMd = $row.children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content');

        if ($colMd.length === 1) {
          $colContentSet = $colMd.children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content');

          if ($colContentSet.children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content').length > 0) {
            data.transform = true;
          }
        }
      }

      ContentManager.removeContentSet(colContentSet);
    }
  }

  return data;
};

/**
 * Remove content, update parent
 * and remove from container
 *
 * @param  {object} content
 */
ContentManager.remove = function(content) {
  if (content instanceof AbstractContent) {
    let $row = content.$.parents('.row:first');
    let data = ContentManager.removeHtml(content);

    if (data.transform) {
      let $colContentSet = $row.children().not('.cloud-dnd, .cloud-column-resize').children().not('.cloud-dnd, .cloud-column-resize');

      ContentManager.transformColContentSet($colContentSet).done(function() {
        SaveManager.save();
      });
    }

    ContentRepository.delete(content.type, content.uid);

    ContentContainer.remove(content);
  }
};

/**
 * Remove contentset when is empty
 *
 * @param  {object} contentSet
 */
ContentManager.removeContentSet = function(contentSet) {
  if (contentSet.isContentSet()) {
    contentSet.$.remove();

    if (contentSet.type === 'CloudContentSet') {
      this.getRootContentSet().setUpdated(true);
    }

    ContentContainer.remove(contentSet);

    contentSetToRemove.push({
      'uid': contentSet.uid,
      'type': contentSet.type,
    });
  }
};

/**
 * Clear all empty contentSet
 *
 */
ContentManager.clearContentSet = function() {
  _.forEach(contentSetToRemove, function(object) {
    ContentRepository.delete(object.type, object.uid);
  });

  contentSetToRemove = [];
};

/**
 * Create new element by type
 * and resolve by an AbstractContent
 *
 * @param  {string} type
 * @param  {object} [data] data
 * @returns {*} promise
 */
ContentManager.createElement = function(type, data) {
  let dfd = jQuery.Deferred();
  let self = this;

  if (!_.isString(type)) {
    throw new Error('Type must be set in ContentManager::createElement');
  }

  ContentRepository.save({'type': type, 'data': data}).done(function(data, response) {
    const resourceUID = response.getHeader(HEADER_RESOURCE_UID) || response.getHeader(HEADER_RESOURCE_UID.toLowerCase());
    dfd.resolve(self.buildElement({'type': type, 'uid': resourceUID}));

    return data;
  }).fail(function() {
    dfd.reject();
  });

  return dfd.promise();
};

ContentManager.createElementWithSub = function(parentType, childType) {
  let dfd = jQuery.Deferred();

  ContentManager.createElement(childType).done(function(child) {
    ContentManager.createElement(parentType, {
      'elements': [
        {
          'uid': child.uid,
          'type': child.type,
        },
      ],
    }).done(function(parent) {
      dfd.resolve(parent, child);
    });
  });

  return dfd.promise();
};

ContentManager.refreshImages = function(html, forceUpdate) {
  jQuery(html).find('img').each(function() {
    let img = jQuery(this);

    if (true === forceUpdate && img.attr('src')) {
      img.attr('src', img.attr('src') + '?' + new Date().getTime());
    }
  });
};

/**
 * Retrieve content by a jQuery node
 *
 * @param  {jQuery} node
 * @returns {object} AbstractContent
 */
ContentManager.getContentByNode = function(node) {
  if (!(node instanceof jQuery)) {
    throw new Error('Node must be an instance of jQuery in ContentManager::getContentByNode');
  }

  let content;
  let id = node.data('bb-id');
  let identifier = node.data('bb-identifier');
  let config;

  if (_.isString(id)) {
    content = this.buildElement({
      'id': id,
      '$': node,
    });

    if (null !== content) {
      return content;
    }
  }

  if (!_.isString(identifier)) {
    throw new Error('Node is not a content in ContentManager::getContentByNode');
  }

  config = ObjectIdentifier.getObject(identifier);

  if (null === config) {
    throw new Error('Node is not a content in ContentManager::getContentByNode');
  }

  config.$ = node;

  return this.buildElement(config);
};

module.exports = ContentManager;
